import {
    Breadcrumb,
    Button,
    Input,
    Modal,
    Popconfirm,
    Row,
    Select,
    Space,
    Table,
    Tooltip,
  } from "antd";
  import "antd/dist/antd.min.css";
  import { debounce } from "lodash";
  import React, { useEffect, useState } from "react";
  import { confirmAlert } from "react-confirm-alert";
  import { useTranslation } from "react-i18next";
  import { Link, useNavigate } from "react-router-dom";
  import { getRequest, patchRequest, postRequest } from "../../../axios";
  import ButtonField from "../../../common/htmlComponents/ButtonField";
  import BulkUploadCsv from "../../../image/AddCsvFile.png";
  import { ReactComponent as Archive } from "../../../image/Archive.svg";
  import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
  import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
  import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
  import SearchIcon from "../../../image/SearchIcon.svg";
  import "../../../styles/Main.scss";
  import { authUserData } from "../../../utils/Helper";
  import {
    ErrorNotificationMsg,
    SuccessNotificationMsg,
  } from "../../../utils/Notifications";
import AddSubCategory from "./AddSubCategory";
  
  const { Search } = Input;
  
  const SubCategoryList = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [pincodeList, setPincodeList] = useState([]);
    const [totalCount, settotalCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);
    const [reload, setReload] = useState(false);
    const [categoryId, setCategoryId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newCategoryAdded, setNewCategoryAdded] = useState(false);
    const [categoryTreeId, setCategoryTreeId] = useState(null);
    const [modalKey, setModalKey] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [categoryTree, setCategoryTree] = useState([]);
    // State initiailisation
    const [state, setState] = useState({
      page: 1,
      ordering: "-id",
      pagesize: 10,
      search: "",
      total: 0,
    });

      const getCategoryTree = async (data) => {
        await getRequest("category-tree/?no_pagination=True", data).then(
          (response) => {
            setCategoryTree(response.data.data);
          }
        );
      };
        useEffect(() => {
          getCategoryTree();
        }, []);
  
    // fetch Category List API
    useEffect(() => {
      const getCategoryList = async () => {
        setLoading(true);
  
        try {
          let apiResponse = await getRequest("sub-category/", state);
  
          if (apiResponse.data.results.success) {
            setPincodeList(apiResponse.data.results.data);
            settotalCount(apiResponse.data.count);
          } else {
            ErrorNotificationMsg(t("error_in_list_category"));
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };
  
      getCategoryList();
    }, [state, newCategoryAdded, reload, t]);
  
    // Function to handle changes in table pagination, filters, and sorting
    const handleTableChange = async (pagination, filters, sorter, ordering) => {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setState({
        ...state,
        page: pagination.current,
        pagesize: pagination.pageSize,
        ordering: orderBy,
      });
      setSelectedRow(selectedRow);
    };
  
      // Function of Shorting enum Value
    const GetSortingEnumValue = (sortField, sortOrder) => {
      let sortingEnumKey = "-id";
  
      if (sortField === "name" && sortOrder === "ascend") {
        sortingEnumKey = "name";
      }
      if (sortField === "name" && sortOrder === "descend") {
        sortingEnumKey = "-name";
      }
  
      if (sortField === "description" && sortOrder === "ascend") {
        sortingEnumKey = "description";
      }
      if (sortField === "description" && sortOrder === "descend") {
        sortingEnumKey = "-description";
      }
      if (sortField === "gst_rate" && sortOrder === "ascend") {
        sortingEnumKey = "gst_rate";
      }
      if (sortField === "gst_rate" && sortOrder === "descend") {
        sortingEnumKey = "-gst_rate";
      }
      if (sortField === "status" && sortOrder === "ascend") {
        sortingEnumKey = "status";
      }
      if (sortField === "status" && sortOrder === "descend") {
        sortingEnumKey = "-status";
      }
  
      return sortingEnumKey;
    };
  
    // fuuncion to handle the status
    const handleStatus = async (user_id, status) => {
      confirmAlert({
        title: t("confirmAlert_title"),
        message: t("confirmAlert_message"),
        buttons: [
          {
            label: t("confirmAlert_ok"),
            onClick: () => changeStatus(user_id, status),
          },
          {
            label: t("confirmAlert_cancel"),
            onClick: () => navigate("/category"),
          },
        ],
      });
    };
  
    // Function to handle any change in the Status
    const changeStatus = async (user_id, value) => {
      await patchRequest(`category-tree-status/${user_id}/`, { status: value })
        .then((response) => {
          SuccessNotificationMsg(t("status_updated_sucessfully"));
          setLoading(false);
          setReload((reload) => !reload);
        })
        .catch((error) => { });
    };
  
    // Function to Call Back Delayed
    const searchCallbackDelayed = (event) => {
      const { value } = event.target;
      debounceLoadData(value, onSearch);
    };
    const onSearch = (value) => {
      setState({
        ...state,
        search: value,
      });
    };
  
    const debounceLoadData = debounce((value, onSearch) => {
      onSearch(value);
    }, 1000);
    const rowSelection = {
      onSelect: (record, selected, selectedRows) => {
        const updatedSelectedRowKeys = selected
          ? [...selectedRow, record.id]
          : selectedRow.filter((key) => key !== record.id);
        setSelectedRow(updatedSelectedRowKeys);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        const updatedSelectedRowKeys = selected
          ? [...selectedRow, ...changeRows.map((row) => row.id)]
          : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
        setSelectedRow(updatedSelectedRowKeys);
      },
      selectedRowKeys: selectedRow,
    };
  
    // Function to handle the Archive 
    const handleArchive = async (id = "") => {
      let ids = selectedRow;
      if (ids.length === 0) {
        ids.push(id);
      }
      try {
        let apiResponse = await postRequest("sub-category-delete/", {
          deleted: ids,
        });
        if (apiResponse.data.success) {
          let totalArchive = totalCount - ids?.length;
          if (totalArchive < 11) {
            setState((prevState) => ({
              ...prevState,
              page: 1,
              search: "",
            }));
            setReload(!reload);
          } else {
            setReload(!reload);
          }
          SuccessNotificationMsg(t("sub_category_archive_successfully4"));
  
          setSelectedRow([]);
        } else {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          ErrorNotificationMsg(t("error_in_delete_sub_category"));
        }
      } catch (error) {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    };
  
    const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
    const showBulkUpload = () => {
      setIsModalOpenBulk(true);
    };
    const handleOkBulk = () => {
      setIsModalOpenBulk(false);
    };
    const handleCancelBulk = () => {
      setIsModalOpenBulk(false);
    };
    const openImageInNewTab = (imageSrc) => {
      window.open(imageSrc, "_blank");
    };
    const showModal = () => {
      setIsModalOpen(true);
    };
    const handleOk = () => {
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
      setFileList([]);
    };
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        sorter: true,
      },
      {
        title: "Category",
        dataIndex: "category_tree_name",
        key: "category_tree_name",
        sorter: true,
      },
      {
        title: "Sub Category",
        dataIndex: "name",
        key: "name",
        sorter: true,
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        sorter: true,
      },
      // {
      //   title: "GST (%)",
      //   render: (gst_rate) => <>{gst_rate} %</>,
      //   dataIndex: "gst_rate",
      //   key: "gst_rate",
      //   sorter: true,
      // },
      // {
      //   title: "Status",
      //   dataIndex: "status",
      //   key: "status",
      //   width: "250px",
      //   sorter: true,
      //   render: (e, record) => (
      //     <div className="SelectStatusSec">
      //       <Select
      //         value={e ? e : record.status}
      //         onChange={(e) => handleStatus(record.id, e)}
      //         defaultValue={e}
      //       >
      //         <Select.Option value="pending" disabled>
      //           <div className="pendingotp">{t("Pending")}</div>
      //         </Select.Option>
  
      //         <Select.Option value="active">
      //           <div className="activeopt">{t("Active")}</div>
      //         </Select.Option>
  
      //         <Select.Option value="inactive">
      //           <div className="inactiveopt">{t("Inactive")}</div>
      //         </Select.Option>
      //       </Select>
      //     </div>
      //   ),
      // },
  
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Space>
            <Tooltip
              color={colors}
              placement="left"
              title={
                <span style={{ color: "#fff" }}>
                  Edit
                </span>
              }
            >
              {authUserData()?.permission.includes(
                "category_tree|change_categorytree"
              ) &&
                <Editicon onClick={() => handleUpdate(record.id)} style={{ cursor: "pointer" }} />
              }
            </Tooltip>
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Archive
                </span>
              }
            >
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleArchive(record.id)}
              >
                {authUserData()?.permission.includes(
                  "category_tree|delete_categorytree"
                ) && <Archive style={{ cursor: "pointer" }} />}
              </Popconfirm>
            </Tooltip>
          </Space>
        ),
      },
    ];
    const colors = ["#094E8F"];
    const handleUpdate = (id) => {
      setModalKey((prevKey) => !prevKey);
      setCategoryTreeId(id);
      showModal();
    };
    const handleAdd = () => {
      setCategoryTreeId(null);
      showModal();
      setReload((reload) => !reload);
    };
    return (
      <>
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
  
              <h3>{t("pl_subcategory")}</h3>
  
  
              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("pl_subcategory")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Search
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    placeholder={t("pl_search_list")}
                    onChange={searchCallbackDelayed}
                    style={{
                      width: 250,
                    }}
                  />
                </Space>
              </div>
              {authUserData()?.permission.includes(
                "category_tree|add_categorytree"
              ) && (
                  <Tooltip
                    color={colors}
                    placement="right"
                    title={
                      <span style={{ color: "#fff" }}>
                        Create a new sub category for organizing and classifying items or entities within your project or system.
                      </span>
                    }
                  >
                    <Button
                      className="BlueShadowBtn"
                      type="primary"
                      icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                      onClick={handleAdd}
                    >
                      Add Sub Category
                    </Button>
                  </Tooltip>
                )}
              <Modal
                className="ModelPopupSec"
                title={categoryTreeId ? t("Edit Sub Category") : t("Add Sub Category")}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                wrapClassName="modal-wrapper"
                keyboard={false}
              >
                <AddSubCategory
                  fileList={fileList}
                  setFileList={setFileList}
                  reload={reload}
                  setReload={setReload}
                  handleCancel={handleCancel}
                  categoryTreeId={categoryTreeId}
                  modalKey={modalKey}
                  setStateM={setState}
                  categoryTree={categoryTree}

                />
              </Modal>
{/*   
              <Modal
                className="ModelPopupSec"
                title="Upload File"
                open={isModalOpenBulk}
                onOk={handleOkBulk}
                onCancel={handleCancelBulk}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <BulkCategoryUpload
                  setNewCategoryAdded={setNewCategoryAdded}
                  newCategoryAdded={newCategoryAdded}
                  categoryId={categoryId}
                  handleCancelBulk={handleCancelBulk}
                />
              </Modal> */}
              {selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive()}
                >
                  {authUserData()?.permission.includes(
                    "category_tree|delete_categorytree"
                  ) && (
                      <ButtonField
                        className="BlueShadowBtn"
                        type="primary"
                        htmlType="button"
                        label="Archive"
                      />
                    )}
                </Popconfirm>
              )}
  
              <Tooltip placement="topLeft" title="View Archived Records">
                <Link to="/sub-category/archive" className="Archiveicon">
                  <Archiveicon />
                </Link>
              </Tooltip>
      
            </Space>
          </div>
        </div>
  
        <section className="grid-sec mt-5">
          <div className="PR-body">
            <Row className="tblheader">
            </Row>
  
            <Table
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              columns={columns}
              dataSource={pincodeList}
              scroll={{ x: 800 }}
              loading={loading}
              pagination={{
                current: state.page,
                pageSize: state.pagesize,
                total: totalCount,
                showSizeChanger: true,
                showTotal: (totalCount) => `Total ${totalCount} items`,
                locale: {
                  items_per_page: 'Items / Page', // Text for the size changer
                },
              }}
              onChange={handleTableChange}
            />
          </div>
        </section>
      </>
    );
  };
  
  export default SubCategoryList;
  